import(/* webpackMode: "eager" */ "/home/runner/work/integrations-monorepo/integrations-monorepo/apps/go-high-level/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/integrations-monorepo/integrations-monorepo/apps/go-high-level/src/components/auth-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/integrations-monorepo/integrations-monorepo/apps/go-high-level/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/home/runner/work/integrations-monorepo/integrations-monorepo/apps/go-high-level/src/trpc/react.tsx");
